import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      {/* ヘッダー */}
      <header className="header">
        <div className="container">
          <div className="logo">すずくり</div>
          <nav className="nav">
            <a href="#business">事業内容</a>
            <a href="#services">サービス</a>
            <a href="#development">受託開発</a>
            <a href="#portfolio">開発実績</a>
            <a href="#about">会社概要</a>
            <a href="#contact">お問い合わせ</a>
          </nav>
        </div>
      </header>

      {/* ヒーローセクション */}
      <section className="hero">
        <div className="container">
          <h1 className="hero-title">作りたいものをクリエイトする</h1>
          <p className="hero-subtitle">
            私たちは、FastFactとポタリカをはじめとする革新的なサービスを提供し、<br />
            便利な世界を実現させることを目指しています。
          </p>
          <a href="#services" className="cta-button">サービスを見る</a>
        </div>
      </section>

      {/* 事業内容セクション */}
      <section id="business" className="business">
        <div className="container">
          <h2 className="section-title">事業内容</h2>
          <div className="business-content">
            <div className="business-item">
              <h3 className="business-title">自社サービス開発</h3>
              <p className="business-description">
                FastFactやポタリカなど、社会課題を解決する自社サービスを開発・運営しています。
                ユーザーのニーズに応える革新的なソリューションを提供します。
              </p>
            </div>
            <div className="business-item">
              <h3 className="business-title">受託開発</h3>
              <p className="business-description">
                お客様のビジネス課題を解決するシステム開発を承っています。<br />
                ウェブアプリケーションから業務効率化まで、幅広い技術領域に対応可能です。
              </p>
            </div>
            <div className="business-item">
              <h3 className="business-title">システムエンジニアリングサービス（SES）</h3>
              <p className="business-description">
                実際にプロジェクトに入り、システム開発をサポートします。<br />
                技術的にはPHP,Python3,<br />GoogleAppScriptの対応が可能です。<br />
                また、他の言語の場合もご相談ください。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* サービス紹介セクション */}
      <section id="services" className="services">
        <div className="container">
          <h2 className="section-title">提供サービス</h2>
          <div className="services-grid">
            <div className="service-card">
              <a href="https://fast-fact.jp/" target="_blank" rel="noopener noreferrer">
                <h3 className="service-title">FastFact</h3>
              </a>
              <p className="service-description">
                一時情報を提供するポータルサイトです。
                誇大された見出しが多い現代で、情報の提供元が伝えたい情報を正確に伝えることをサービスを目指しています。
              </p>
            </div>
            <div className="service-card">
              <a href="https://potalica.com/" target="_blank" rel="noopener noreferrer">
                <h3 className="service-title">ポタリカ</h3>
              </a>
              <p className="service-description">
                薬局を買収して独立したい薬剤師と薬局をつなぐプラットフォームです。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 受託開発セクション */}
      <section id="development" className="development">
        <div className="container">
          <h2 className="section-title">受託開発</h2>
          <p className="development-intro">
            お客様のニーズに合わせたカスタム開発を承っております。<br />
            ウェブアプリケーション、業務効率化、システム開発など、幅広い技術領域に対応可能です。
          </p>
          
          <div className="development-grid">
            <div className="development-card">
              <h3 className="development-card-title">要件定義から運用まで</h3>
              <p className="development-card-description">
                プロジェクトの初期段階から運用まで、一貫したサポートを提供します。
                お客様のビジネス目標を理解し、最適なソリューションを提案します。
              </p>
            </div>
            
            <div className="development-card">
              <h3 className="development-card-title">最新技術の活用</h3>
              <p className="development-card-description">
                最新の技術トレンドを常にキャッチアップし、
                お客様のプロジェクトに最適な技術を選択・活用します。
              </p>
            </div>
            
            <div className="development-card">
              <h3 className="development-card-title">柔軟な開発手法</h3>
              <p className="development-card-description">
                アジャイル開発手法を採用し、変化する要件にも柔軟に対応。
                迅速なフィードバックと改善サイクルで、品質の高い成果物を提供します。
              </p>
            </div>
            
            <div className="development-card">
              <h3 className="development-card-title">保守・運用サポート</h3>
              <p className="development-card-description">
                開発後の保守・運用も充実したサポート体制で対応。
                長期的な安定稼働をサポートします。
              </p>
            </div>
          </div>

          <div className="tech-stack">
            <h3 className="tech-stack-title">対応可能な技術</h3>
            <div className="tech-tags">
              <span className="tech-tag">PHP</span>
              <span className="tech-tag">Python3</span>
              <span className="tech-tag">Google App Script</span>
              <span className="tech-tag">JavaScript</span>
              <span className="tech-tag">React</span>
              <span className="tech-tag">Node.js</span>
              <span className="tech-tag">その他ご相談ください</span>
            </div>
          </div>
        </div>
      </section>

      {/* 開発実績セクション */}
      <section id="portfolio" className="portfolio">
        <div className="container">
          <h2 className="section-title">開発実績</h2>
          <div className="portfolio-grid">
            <div className="portfolio-item">
              <h3 className="portfolio-title">データ収集スクレイピングシステム</h3>
              <p className="portfolio-description">
                不動産業者向けに物件情報を収集するシステムを開発しました。
                データ収集スクレイピングを行い、データを分析して条件に合った物件をピックアップしてスプレッドシートに追加していくシステムを開発しました。
              </p>
            </div>
            <div className="portfolio-item">
              <h3 className="portfolio-title">ポッドキャスト配信システム</h3>
              <p className="portfolio-description">
                ポッドキャスト配信を行うシステムの管理画面から提供機能まで一通り開発しました。
              </p>
            </div>
            <div className="portfolio-item">
              <h3 className="portfolio-title">AIを用いた業務自動化システム</h3>
              <p className="portfolio-description">
                AIを用いて毎日手動で入力していた業務を自動化させるシステムを構築しました。
              </p>
            </div>
            <div className="portfolio-item">
              <h3 className="portfolio-title">AIを用いたデザイン業務の改善</h3>
              <p className="portfolio-description">
                AIを用いて筐体のデザインの自動で生成するシステムを構築しています。
                AIに自動生成することで、固定概念から外れるデザインなどが生まれデザインの幅が広がりそうだと期待されています。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 会社概要セクション */}
      <section id="about" className="about">
        <div className="container">
          <h2 className="section-title">会社概要</h2>
          <div className="about-content">
            <table className="about-table">
              <tbody>
                <tr>
                  <th>会社名</th>
                  <td>すずくり株式会社</td>
                </tr>
                <tr>
                  <th>設立</th>
                  <td>2023年7月20日</td>
                </tr>
                <tr>
                  <th>所在地</th>
                  <td>160-0023<br />東京都新宿区西新宿8丁目11-10 星野ビル3階</td>
                </tr>
                <tr>
                  <th>代表者</th>
                  <td>代表取締役 鈴木裕之</td>
                </tr>
                <tr>
                  <th>事業内容</th>
                  <td>
                    自社サービス開発<br />
                    受託開発<br />
                    システムエンジニアリングサービス（SES）
                  </td>
                </tr>
                <tr>
                  <th>主要サービス</th>
                  <td>
                    <a href="https://fast-fact.jp/" target="_blank" rel="noopener noreferrer">FastFact</a><br />
                    <a href="https://potalica.com/" target="_blank" rel="noopener noreferrer">ポタリカ</a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* お問い合わせセクション */}
      <section id="contact" className="contact">
        <div className="container">
          <h2 className="section-title">お問い合わせ</h2>
          <p className="contact-description">
            サービスに関するお問い合わせや、開発のご相談は<br />
            お気軽にご連絡ください。
          </p>
          <a href="mailto:hiroyuki@suzucre.net" className="contact-button">
            お問い合わせはこちら
          </a>
        </div>
      </section>

      {/* フッター */}
      <footer className="footer">
        <div className="container">
          <p>&copy; 2024 Suzucre. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}

export default App;
